import {MapLayer} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-routing-machine';
import 'leaflet-control-geocoder';
import './lefleat.css';
//import 'lrm-google';
import {withLeaflet} from 'react-leaflet';

class Routing extends MapLayer {
  createLeafletElement() {
    const {map, waypoint, handleChangeLocation} = this.props;
    const icon = L.icon({
      iconUrl:
        'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png',
      iconSize: [40, 40],
    });
    const waypoints = waypoint.map((point: any) =>
      L.latLng(point.lat, point.lon)
    );
    const leafletElement = L.Routing.control({
      waypoints: waypoints,
      plan: L.Routing.plan(waypoints, {
        createMarker: function (i, wp) {
          return L.marker(wp.latLng, {
            draggable: true,
            icon,
          });
        },
        routeWhileDragging: true,
        geocoder: L.Control.Geocoder.nominatim(),
      }),
      // router: new L.Routing.Google(),
      lineOptions: {
        styles: [
          {
            color: 'blue',
            opacity: 0.6,
            weight: 4,
          },
        ],
      },
      addWaypoints: false,
      draggableWaypoints: true,
      fitSelectedRoutes: false,
      showAlternatives: false,
    }).addTo(map.leafletElement);
    leafletElement.hide();
    return leafletElement.getPlan().on('waypointgeocoded', (e: any) => {
      handleChangeLocation(e.target._waypoints);
    });
  }
}
export default withLeaflet(Routing);
